import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { DEFAULT_CONTENT_WIDTH } from '@/features/marketplace/constants';
import { TestimonialsCarousel } from './components/testimonials-carousel';
import { testimonialsData } from './testimonials-data';

const WhatOurHousematesSaySection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="w-full overflow-hidden bg-gray-50 py-8">
      <div className={clsx(DEFAULT_CONTENT_WIDTH, 'm-auto flex-1')}>
        <div className="flex w-full items-center justify-between mb-7">
          <h2 className={clsx(
            'text-h3 font-bold leading-[3.7rem] text-text-primary',
            'sm:text-[4.8rem] sm:leading-[5.5rem]'
          )}>
            {t('js.features.marketplace.home.what_our_housemates_say_section.title')}
          </h2>
        </div>
      </div>
      <TestimonialsCarousel testimonials={testimonialsData} />
    </section>
  );
};

export { WhatOurHousematesSaySection };
